<template>
    <div class="img-box" :style="styleObj">
        <img
            class="customer-cover-img"
            :src="obj.addinfo5"
            alt="cover"
        />
    </div>
</template>

<script setup>

import {computed} from "vue";

const props = defineProps(["obj", "width", "height"])

const styleObj = computed(() => {
    const obj = {}

    if (null != props.width){
        obj.width = `${props.width}px`
    }

    if (null != props.height){
        obj.height = `${props.height}px`
    }

    return obj
})

</script>

<style scoped>

.customer-cover-img {
    width: 100%;
    height: 100%;
    object-fit: scale-down;
    box-sizing: border-box;
    //border: 1px #E4E7ED solid;
}

.img-box {
    text-align: center;
}

</style>